import { useState, useEffect } from 'react';
/** Gibt true zurück wenn der Viewport schmaler als 640px ist. */
export function useMobile(breakpoint = 640) {
    const [mobile, setMobile] = useState(typeof window !== 'undefined' && window.innerWidth < breakpoint);
    useEffect(() => {
        const handler = () => setMobile(window.innerWidth < breakpoint);
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, [breakpoint]);
    return mobile;
}
